import { Reveal, SectionHead } from "@/components/motion";

const TARGETS = ["Hotel Investment", "Feasibility", "Advisory", "Development", "Commercial Strategy"];

export default function CareerDirection() {
  return (
    <section className="border-t border-hairline" data-testid="career-direction">
      <div className="bg-moss">
        <div className="mx-auto max-w-[1400px] px-6 py-28 sm:px-10 sm:py-36">
          <SectionHead
            dark
            label="Career direction"
            title={<>Where I'm heading <em className="text-champagne">next.</em></>}
          />
          <div className="max-w-3xl">
            <Reveal>
              <p className="max-w-2xl font-serif text-2xl sm:text-3xl font-light leading-snug text-paper/90">
                Bringing operational hotel experience and strategic analysis into investment, feasibility, advisory, development and commercial decision-making.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-10 flex flex-wrap gap-2.5">
                {TARGETS.map((t) => (
                  <span
                    key={t}
                    data-testid={`target-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="border border-champagne/40 px-4 py-2 text-[12px] font-semibold uppercase tracking-[0.16em] text-champagne transition-colors duration-300 hover:bg-champagne hover:text-moss"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
